export default __webpack_public_path__ + "static/media/sample1.67ec105b.jpeg";